"use client";

import React from "react";
import { ArrowRight, BookOpen, Calculator, CircleQuestionMark as HelpCircle, Sparkles } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
export default function ConsultationCallToAction() {
  const handleEstimateClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const el = document.getElementById("estimaterequestform");
    if (el) {
      e.preventDefault();
      el.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };
  return <section id="consultationcalltoaction" data-nav="light" className="bg-background text-foreground py-16 md:py-24 border-t border-border overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          {/* Content Column */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl tracking-tight text-foreground font-medium mb-6">
              Start your bathroom transformation with a detailed in-home consultation.
            </h2>
            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed max-w-2xl mb-8">
              Every Brookhaven home has distinct architectural character. We review your current layout, discuss custom tilework, fixtures, and cabinetry, and provide clear scope and pricing for your renovation.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-10">
              <Button asChild size="lg" className="w-full sm:w-auto font-medium">
                <Link to="/ContactRequestAnEstimatePage" onClick={handleEstimateClick}>
                  Request an Estimate
                  <ArrowRight className="size-4 ml-1" />
                </Link>
              </Button>
            </div>

            <Separator className="mb-8" />

            {/* Related Services Row */}
            <div className="mb-8">
              <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground block mb-3">
                Related Services
              </span>
              <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
                <Link to="#" className="text-sm font-medium text-foreground hover:text-primary transition-colors inline-flex items-center gap-1.5">
                  <Sparkles className="size-3.5 text-primary" />
                  Kitchen Remodeling
                </Link>
                <span className="text-border hidden sm:inline" aria-hidden="true">
                  •
                </span>
                <Link to="#" className="text-sm font-medium text-foreground hover:text-primary transition-colors inline-flex items-center gap-1.5">
                  <Sparkles className="size-3.5 text-primary" />
                  Whole-Home Remodeling
                </Link>
              </div>
            </div>

            {/* Helpful Resources Row */}
            <div>
              <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground block mb-3">
                Planning Resources
              </span>
              <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
                <Link to="#" className="text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1.5">
                  <Calculator className="size-3.5" />
                  Remodeling Cost Guide
                </Link>
                <span className="text-border hidden sm:inline" aria-hidden="true">
                  •
                </span>
                <Link to="#" className="text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1.5">
                  <BookOpen className="size-3.5" />
                  Remodeling Planning Guide
                </Link>
                <span className="text-border hidden sm:inline" aria-hidden="true">
                  •
                </span>
                <Link to="#" className="text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1.5">
                  <HelpCircle className="size-3.5" />
                  FAQ
                </Link>
              </div>
            </div>
          </div>

          {/* Imagery Column */}
          <div className="lg:col-span-5">
            <div className="relative rounded-2xl overflow-hidden shadow-lg border border-border bg-card">
              <div className="aspect-[4/5] w-full overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/luxury_bathroom_remodel_shower.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/luxury_bathroom_remodel_shower.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/luxury_bathroom_remodel_shower.webp-wvc-sizes" alt="Custom walk-in shower with natural stone tile and brass fixtures in a renovated Brookhaven bathroom" loading="lazy" decoding="async" className="w-full h-full object-cover object-center transition-transform duration-500 hover:scale-105" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}